import { object, string } from 'yup';

const formValidation = () =>
  object().shape({
    name: string().required(),
    pattern: string().required(),
  });

export default formValidation;
